module.exports = __webpack_public_path__ + "img/naira-sign.e9ad24c5.svg";